/* global window */
import $ from 'jquery';

const stickyElement = () => {
    const cachedElements = [];
    const $window = $(window);
    let settings = {};

    const calculatePosition = () => {
        const scrollPos = $window.scrollTop();

        cachedElements.forEach(el => {
            if (scrollPos >= settings.offset) {
                el.$el
                    .addClass(settings.activeClass)
                    .removeClass(settings.inactiveClass);
                return;
            }

            el.$el.removeClass(settings.activeClass);

            // Prevent from adding inactive class on page load
            if (el.calculated) {
                el.$el.addClass(settings.inactiveClass);
            }

            el.calculated = true;

        });

    };

    const methods = {

        /**
         * @param {object} options
         * @returns {methods}
         */
        init(options) {

            const defaults = {
                $el: null,
                activeClass: 'sticky',
                inactiveClass: 'static',
                offset: 0,
            };

            settings = Object.assign({}, defaults, options);

            for (const el of settings.$el) {
                const $el = $(el);

                cachedElements.push({
                    $el,
                    offset: settings.offset
                });
            }

            return this;
        },
        /**
         * @returns {methods}
         */
        run() {
            $(window).on('scroll.stickyElement', calculatePosition);
            calculatePosition();
            return this;
        },
        /**
         * @returns {methods}
         */
        destroy() {
            // Unbind events
            $(window).off('scroll.stickyElement', calculatePosition);

            // Remove sticky classes
            cachedElements.forEach(el => {
                el.$el.removeClass(settings.activeClass);
                el.$el.removeClass(settings.inactiveClass);
            });

            return this;
        }
    };

    return {
        init: methods.init,
        run: methods.run,
        destroy: methods.destroy
    }
};

export default stickyElement;


// WEBPACK FOOTER //
// ./src/js/modules/stickyElement.js